function timeToText(datetime?: string): string {
  if (!datetime) {
    return "";
  }

  try {
    const published = new Date(datetime).getTime();
    const now = Date.now();
    const minutes = (now - published) / 60000;
    if (minutes < 60) {
      return "1 hour ago";
    }
    const hours = minutes / 60;
    if (hours < 14) {
      return `${hours.toFixed(0)} hours ago`;
    } else if (hours < 24) {
      return "1 day ago";
    }

    const days = hours / 24;
    if (days <= 7) {
      return `${days.toFixed(0)} days ago`;
    }

    const weeks = days / 7;
    if (weeks < 4) {
      return `${Math.ceil(weeks)} weeks ago`;
    }

    const months = weeks / 4;
    return `${Math.ceil(months)} months ago`;
  } catch (err) {}

  return "";
}

function timeToMidnightUTC(datetime?: string): string {
  return !datetime ? "" : datetime.split("T")[0] + "T00:00:00.000Z";
}

export default {
  timeToText,
  timeToMidnightUTC,
};
